import { render, staticRenderFns } from "./groupsTab.vue?vue&type=template&id=95455100&"
import script from "./groupsTab.vue?vue&type=script&lang=js&"
export * from "./groupsTab.vue?vue&type=script&lang=js&"
import style0 from "./groupsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports